<template>
  <multiselect
      v-model="selectedItem"
      @update:modelValue="onSelectItem"
      :options="optionsList"
      :placeholder="$t('settings.generic.select-items')"
      label="translationKey" track-by="value"
      class="tracking-multiselect fit-content statuses-select"
      :multiple="false"
      :close-on-select="true"
      :clear-on-select="false"
      :preserve-search="true"
      :show-labels="false"
      :show-no-results="false"
      :show-no-options="false"
      :allow-empty="false"
  >
    <template #placeholder>
      <span>
        {{ $t('settings.generic.select-placeholder') }}
      </span>
    </template>
    <template #option="props">
      <div class="tracking-multiselect-with-checkbox">
        <span class="option__title">{{ $t(props.option?.translationKey ?? '') }}</span>
      </div>
    </template>
    <template #singleLabel>
      <span class="option__title pr-5">
        <span class="option__title">{{ $t(selectedItem?.translationKey ?? '') }}</span>
      </span>
    </template>
  </multiselect>
</template>

<script>

import Multiselect from "vue-multiselect";
import {TaskStatus} from "@/assets/js/enums/TaskStatus.ts";

export default {
  name: "ChooseTaskStatus",
  components: {Multiselect},
  props: {
    modelValue: {
      type: [Number],
      default() { return null; }
    },
    addAllOption: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      selectedItem: null,
    }
  },
  computed: {
    optionsList() {
      const taskStatuses = TaskStatus.all();
      if (this.addAllOption) {
        taskStatuses.unshift({value: null, translationKey: 'generic.all'});
      }

      return taskStatuses;
    },
    isAllSelected() {
      return !this.selectedStatus;
    },
    selectedStatus() {
      return this.selectedItem?.value;
    }
  },
  mounted() {
    this.selectedItem = this.modelValue;
    if (this.selectedItem || this.addAllOption) {
      const selectedItem = this.optionsList.find(x => x.value === this.selectedItem);
      this.onSelectItem(selectedItem, false);
    }
  },
  watch: {
    modelValue(value) {
      const selectedItem = this.optionsList.find(x => x.value === value);
      this.onSelectItem(selectedItem, false);
    }
  },
  methods: {
    onSelectItem(data, triggerValueUpdate = true) {
      this.selectedItem = data;
      if (triggerValueUpdate) {
        this.$emit('update:modelValue', this.selectedItem?.value);
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.statuses-select {
  width: 173px;
}

// Mobile:
@media (max-width: $breaking-point) {
  .statuses-select {
    width: 100%;
  }
}
</style>